// libs
import React, { memo } from 'react';

// helpers
import { inPriceFormat } from 'shared/helpers/utils';

// styles
import { Container, Discount, Amount, OriginalPrice, Currency } from './styles';

// constants
import { DEFAULT_CURRENCY } from 'shared/constants';
const DISCOUNT_TEXT = '%';

export interface IPriceWithDiscountProps {
  discount?: string | number;
  discountedPrice?: number;
  price: string | number;
  hidePercentage?: boolean;
  className?: string;
}

function Price({
  discount = 0,
  discountedPrice,
  price,
  hidePercentage = false,
  className,
}: IPriceWithDiscountProps) {
  if (price === undefined) {
    return null;
  }

  const formattedPrice = inPriceFormat(price);

  return discount > 0 ? (
    <Container className={className} data-test="discount-price-container">
      <Amount data-test="discounted-price">
        <Currency data-test="currency">{DEFAULT_CURRENCY}</Currency>
        {inPriceFormat(discountedPrice)}
      </Amount>
      <OriginalPrice data-test="original-price">
        <Currency data-test="currency">{DEFAULT_CURRENCY}</Currency>
        {formattedPrice}
      </OriginalPrice>
      {hidePercentage === false && (
        <Discount data-test="discount-percent">
          {discount}
          {DISCOUNT_TEXT}
        </Discount>
      )}
    </Container>
  ) : (
    <Container className={className} data-test="no-discount-price-container">
      <Amount data-test="amount">
        <Currency data-test="currency">{DEFAULT_CURRENCY}</Currency>
        {formattedPrice}
      </Amount>
    </Container>
  );
}

export default memo(Price);
